import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DropDownMultiselect.css';
import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { addQueryStringMultiple } from '../../../Listing';
import { ReactComponent as IconChevronDown } from "../../../../resources/icons/IconChevronDown.svg";
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../../resources/icons/IconArrowRight.svg';
import { get, canUseDOM } from '../../../../utils';
var commonStyles = "cbf3x4i";
var ltrStyles = "l1xkn766";
var rtlStyles = "r1bq1qlk";
var createFacets = function createFacets(tagsToDisplay, facetValues) {
  var filteredOptions = [];
  if (facetValues) {
    filteredOptions = tagsToDisplay && tagsToDisplay.length !== 0 ? tagsToDisplay.map(function (tag) {
      var value = get(tag, 'title.value') || get(tag, 'title.name');
      var name = get(tag, 'name');
      var quantity = facetValues[value] || facetValues[name];
      return quantity ? {
        key: value || name || '',
        label: quantity,
        name: name
      } : null;
    }).filter(function (item) {
      return item;
    }) : [Object.keys(facetValues).map(function (item) {
      return {
        key: item,
        label: facetValues[item],
        name: item
      };
    })];
  }
  return filteredOptions;
};
var DropDownMultiselect = function DropDownMultiselect(_ref) {
  var filter = _ref.filter,
    algoliaResponcedFacetValues = _ref.algoliaResponcedFacetValues,
    closeMobileOpener = _ref.closeMobileOpener,
    setValue = _ref.setValue,
    value = _ref.value,
    clearText = _ref.clearText,
    ctaText = _ref.ctaText,
    setListingFilter = _ref.setListingFilter,
    externalVisible = _ref.externalVisible,
    setExternalVisible = _ref.setExternalVisible,
    analyticButtonCallback = _ref.analyticButtonCallback,
    analyticCheckboxCallback = _ref.analyticCheckboxCallback,
    resetAndSubmitFilters = _ref.resetAndSubmitFilters,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var history = useHistory();
  var labelText = get(filter, 'title.jss.value');
  var tagsToDisplay = get(filter, 'tagsToDisplay.values');
  var facetName = get(filter, 'fieldNameItem.item.fieldName.value');
  var _useState = useState(_toConsumableArray(value)),
    _useState2 = _slicedToArray(_useState, 2),
    localValues = _useState2[0],
    setLocalValues = _useState2[1];
  var fieldOpenedRef = useRef(null);
  var filterName = get(filter, 'name') || '';
  var fieldId = filterName ? filterName.toLowerCase().replace(/ /g, '-') : '';
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    filteredOptions = _useState4[0],
    setfilteredOptions = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    fieldVisible = _useState6[0],
    setFieldVisible = _useState6[1];
  useEffect(function () {
    setfilteredOptions(createFacets(tagsToDisplay, algoliaResponcedFacetValues));
  }, [algoliaResponcedFacetValues, tagsToDisplay]);
  useEffect(function () {
    setLocalValues(_toConsumableArray(value));
  }, [value]);
  var commonSubmit = function commonSubmit(selectedFields) {
    closeMobileOpener();
    addQueryStringMultiple(facetName, selectedFields, history);
    setListingFilter();
    setFieldVisible(false);
  };
  var submitFilter = function submitFilter() {
    var selected = {};
    filteredOptions.forEach(function (_ref2) {
      var key = _ref2.key;
      selected[key] = localValues.includes(key);
    });
    var newValue = {
      value: _toConsumableArray(localValues)
    };
    setValue(newValue);
    analyticButtonCallback(filterName, newValue);
    commonSubmit(selected);
  };
  var clearFilter = function clearFilter() {
    var selected = {};
    filteredOptions.forEach(function (_ref3) {
      var key = _ref3.key;
      selected[key] = false;
    });
    setLocalValues([]);
    setValue({
      value: []
    });
    if (Object.keys(selected).length === 0) {
      resetAndSubmitFilters();
      closeMobileOpener();
      setFieldVisible(false);
    } else {
      commonSubmit(selected);
    }
  };
  var hideDD = function hideDD(e) {
    if (fieldOpenedRef.current) {
      var mobileDevice = withMapModalView ? true : window.matchMedia("(max-width: 991px)").matches;
      if (e.type === 'scroll') {
        if (mobileDevice) return;
      }
      if (e.type === 'click') {
        if (mobileDevice || e.target.closest("#".concat(fieldId))) return;
      }
      setFieldVisible(false);
    }
  };
  useEffect(function () {
    fieldOpenedRef.current = fieldVisible;
  }, [fieldVisible]);
  useEffect(function () {
    if (externalVisible && externalVisible === filterName) {
      setFieldVisible(true);
      setExternalVisible('');
    }
  }, [externalVisible, filterName, setExternalVisible]);
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('scroll', hideDD);
      document.addEventListener("click", hideDD);
    }
    return function () {
      if (canUseDOM) {
        window.removeEventListener('scroll', hideDD);
        document.removeEventListener("click", hideDD);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    id: fieldId
  }, /*#__PURE__*/React.createElement("div", {
    className: "button d-none d-lg-flex ".concat(fieldVisible ? 'button--active' : ''),
    onClick: function onClick() {
      setFieldVisible(!fieldVisible);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "button__text"
  }, labelText), /*#__PURE__*/React.createElement(IconChevronDown, null)), fieldVisible && /*#__PURE__*/React.createElement("div", {
    className: "dropdown ".concat(filteredOptions.length && filteredOptions.length > 8 ? "dropdown--scrollable" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: function onClick() {
      setFieldVisible(false);
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, labelText), /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: clearFilter
  }, clearText)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body__clear d-none d-lg-block"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn-link",
    onClick: clearFilter
  }, clearText)), filteredOptions.map(function (singleValue, index) {
    var tagValue = singleValue.key;
    var idKey = "".concat(facetName, "_").concat(singleValue.key.replace(/\s/g, '_'));
    return /*#__PURE__*/React.createElement("label", {
      className: "fp__inner-label",
      htmlFor: idKey,
      key: "".concat(facetName, "_").concat(index)
    }, /*#__PURE__*/React.createElement("input", {
      checked: localValues.includes(tagValue),
      className: "input-choice fp__checkbox",
      type: "checkbox",
      value: tagValue,
      id: idKey,
      onChange: function onChange() {
        if (tagValue && !localValues.includes(tagValue)) {
          analyticCheckboxCallback("".concat(filterName, " : ").concat(tagValue));
        }
        var newValues = localValues.includes(tagValue) ? localValues.filter(function (item) {
          return item !== tagValue;
        }) : [].concat(_toConsumableArray(localValues), [tagValue]);
        setLocalValues(newValues);
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, singleValue.key, ' (', singleValue.label, ')'), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    disabled: false,
    onClick: submitFilter
  }, ctaText)))));
};
export default DropDownMultiselect;